 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import ALSOBYGEORGEBELLAIRS from '@/components/also-by-george-bellairs'
 import LOVE_1 from '@/components/love_1'
 import VOL001 from '@/components/vol-001'
 import VOL001CHAPTER001 from '@/components/vol-001-chapter-001'
 import VOL001CHAPTER002 from '@/components/vol-001-chapter-002'
 import VOL001CHAPTER003 from '@/components/vol-001-chapter-003'
 import VOL001CHAPTER004 from '@/components/vol-001-chapter-004'
 import VOL001CHAPTER005 from '@/components/vol-001-chapter-005'
 import VOL001CHAPTER006 from '@/components/vol-001-chapter-006'
 import VOL001CHAPTER007 from '@/components/vol-001-chapter-007'
 import VOL001CHAPTER008 from '@/components/vol-001-chapter-008'
 import VOL001CHAPTER009 from '@/components/vol-001-chapter-009'
 import VOL001CHAPTER010 from '@/components/vol-001-chapter-010'
 import VOL001CHAPTER011 from '@/components/vol-001-chapter-011'
 import VOL001CHAPTER012 from '@/components/vol-001-chapter-012'
 import VOL001CHAPTER013 from '@/components/vol-001-chapter-013'
 import VOL001CHAPTER014 from '@/components/vol-001-chapter-014'
 import VOL001CHAPTER015 from '@/components/vol-001-chapter-015'
 import LOVE_2 from '@/components/love_2'
 import VOL002 from '@/components/vol-002'
 import VOL002CHAPTER001 from '@/components/vol-002-chapter-001'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import VOL001COPYRIGHT from '@/components/vol-001-copyright'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/also-by-george-bellairs",
 			"name" : "also-by-george-bellairs",
 			"component" : ALSOBYGEORGEBELLAIRS
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/vol-001",
 			"name" : "vol-001",
 			"component" : VOL001
 		},
 		{
 			"path" : "/vol-001-chapter-001",
 			"name" : "vol-001-chapter-001",
 			"component" : VOL001CHAPTER001
 		},
 		{
 			"path" : "/vol-001-chapter-002",
 			"name" : "vol-001-chapter-002",
 			"component" : VOL001CHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js